import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  private months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  transform(value: string | Date): string {
    if (!value) return '';

    let date: Date;

    // If it's a string in ISO format (YYYY-MM-DD)
    if (typeof value === 'string') {
      // Verify if it's ISO format
      if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
        date = new Date(value + 'T00:00:00'); // Avoid timezone issues
      } else {
        date = new Date(value);
      }
    } else {
      date = value;
    }

    // Verify if the date is valid
    if (isNaN(date.getTime())) {
      return value.toString();
    }

    const day = date.getDate();
    const month = this.months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}
